import { ReactText } from "react"
import { z } from "zod"

export const getEurotaxCustomerSchema = (t: (key: ReactText) => string) =>
    z.object({
        firstName: z.string().optional(),
        lastName: z.string().optional(),
    })

export const getEurotaxVehicleSchema = (t: (key: ReactText) => string) =>
    z.object({
        mileage: z.number({ required_error: t(37) }),
        initialRegistration: z.preprocess(
            (val) => {
                if (typeof val === "string") {
                    const date = new Date(val)
                    return isNaN(date.getTime()) ? undefined : date
                }
                return val
            },
            z.date({ required_error: t(289).replace("#1#", "8"), invalid_type_error: t(289).replace("#1#", "8") })
        ),
        plateNumber: z.string().trim().min(1, t(37)),
        vin: z.string().trim().min(17, t(289).replace("#1#", "17")),
    })
